import React, { FC, useRef } from "react";
import type { CrossBorderPaymentsProps } from "@/types";
import { ContentManager } from "../content-manager";
import Image from "next/image";
import { useInView } from "@/hooks/reveal-in-view";
import SplitTextAnimation from "../split-text-animation";

export const CrossBorderPayments: FC<CrossBorderPaymentsProps> = ({ content }) => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "0px 0px 25% 0px" });
  return (
    <section className="crossBorderPayments">
      <div className="wrapper wrapper" ref={ref}>
        <div
          className="crossBorderPayments--inner"
          style={{
            transform: isInView ? "none" : `translateY(20px)`,
            opacity: isInView ? 1 : 0,
            transition: "all 0.5s cubic-bezier(0.17, 0.55, 0.55, 1)",
          }}
        >
          <SplitTextAnimation
            htmlElement={
              <ContentManager
                content={content}
                className="crossBorderPayments--content"
                style={{
                  transform: isInView ? "none" : `translateY(20px)`,
                  opacity: isInView ? 1 : 0,
                  transition: "all 0.5s cubic-bezier(0.17, 0.55, 0.55, 1)",
                }}
              />
            }
            isInView={isInView}
          />
          <Image
            src="/images/spiral-2.webp"
            alt="Spiral"
            width={1288}
            height={1582}
            draggable={false}
            className="crossBorderPayments--bg"
          />
        </div>
      </div>
    </section>
  );
};
